module.exports = __webpack_public_path__ + "static/media/sklsi-logo.0a3634cc.png";